module.exports = __webpack_public_path__ + "img/02.5a921e6d.png";